import { render, staticRenderFns } from "./AlphaKeys.vue?vue&type=template&id=613a6875&scoped=true&"
import script from "./AlphaKeys.vue?vue&type=script&lang=js&"
export * from "./AlphaKeys.vue?vue&type=script&lang=js&"
import style0 from "./AlphaKeys.vue?vue&type=style&index=0&id=613a6875&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "613a6875",
  null
  
)

export default component.exports